import { Alert, Button, Card, CardBody } from "reactstrap";
import WizardPanel from "../WizardPanel";

const APPTUNE_OPENED_KEY = "userCreationAppTuneOpened";

/** @param {import("../WizardCard").StepPanelProps} props */
export default function UserCreationPanel({ draftFields, setDraftField, status, bottomNav }) {
  const apptuneUrl = process.env.REACT_APP_APPTUNE_URL;
  const apptuneOpened = Boolean(draftFields?.[APPTUNE_OPENED_KEY]);

  const openApptune = () => {
    if (!apptuneUrl) return;
    window.open(`${apptuneUrl}/users`, "_blank", "noopener,noreferrer");
    setDraftField(APPTUNE_OPENED_KEY, true);
  };

  return (
    <WizardPanel
      title="User Creation"
      subtitle="Create the client account directly in AppTune, then come back here"
      status={status}
      bottomNav={bottomNav}
    >
      <Card className="mb-3">
        <CardBody>
          <h6 className="mb-2">Create the user in AppTune</h6>
          <p className="text-muted small mb-3">
            User creation lives in AppTune. Open it in a new tab, fill in the client&apos;s details, then come back here
            and click <em>Mark as Done</em>.
          </p>
          <div className="d-flex align-items-center flex-wrap" style={{ gap: "0.75rem" }}>
            <Button color="primary" disabled={!apptuneUrl} onClick={openApptune}>
              <i className="fas fa-external-link-alt mr-2" />
              Create user in AppTune
            </Button>
            {apptuneOpened && (
              <small className="text-success">
                <i className="fas fa-check-circle mr-1" />
                AppTune opened — finish up there, then click Mark as Done.
              </small>
            )}
            {!apptuneUrl && (
              <small className="text-danger">
                <i className="fas fa-exclamation-circle mr-1" />
                REACT_APP_APPTUNE_URL is not set in the current environment.
              </small>
            )}
          </div>
        </CardBody>
      </Card>

      <Alert color="light" className="small mb-0">
        Once the user exists in AppTune, the client receives their credentials via the standard AppTune flow. No extra
        push from Manager is needed.
      </Alert>
    </WizardPanel>
  );
}
